import { useQuery, useQueryClient } from '@tanstack/react-query'
import type { GetVideoDetailResponse, GetVideosRequest, GetVideosResponse } from './type'
import instance from '@/config/axios'
import type { VideoId } from '@/types/common'
import type { PutVideoSettingRequest } from '../brands/type'
import { useCollableMutation } from '@/config/useCollableMutation'

export const apiGetVideos = async (payload?: GetVideosRequest) => {
  const { data } = await instance.get<GetVideosResponse>('/v1/videos', { params: payload })
  return data
}

export const useGetVideos = (payload?: GetVideosRequest, enabled = true) => {
  return useQuery({
    queryKey: ['videos', payload],
    queryFn: () => apiGetVideos(payload),
    enabled: !Number.isNaN(payload?.channelId) && enabled,
  })
}

export const apiGetVideoDetail = async (id: VideoId) => {
  const { data } = await instance.get<GetVideoDetailResponse>(`/v1/videos/${id}`)
  return data
}

export const useGetVideoDetail = (id: VideoId) => {
  return useQuery({
    queryKey: ['videoDetail', id],
    queryFn: () => apiGetVideoDetail(id),
    enabled: !!id && !Number.isNaN(id),
  })
}

export const apiPutVideoSetting = async (id: VideoId, payload: PutVideoSettingRequest) => {
  const { data } = await instance.put(`/v1/videos/${id}/settings`, payload)
  return data
}

export const usePutVideoSetting = (id: VideoId) => {
  const queryClient = useQueryClient()
  return useCollableMutation({
    mutationFn: (payload: PutVideoSettingRequest) => apiPutVideoSetting(id, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['videoDetail', id] })
      queryClient.invalidateQueries({ queryKey: ['videos'], type: 'all' })
    },
  })
}
